import * as React from 'react'
import {
  UWPNotifier,
  OutputAction,
  DownloadStatus,
  StatusMessage,
  AllDownloadsPayload,
} from '@shared'

import {
  DownloadButtonWithLabel,
  DownloadButton,
} from './DownloadButton'
import {
  DownloadStatusMessages
} from './DownloadStatusMessages'
import {
  count
} from '../../../widgets/DVWebNodeSPA/utils/csm'
import { DropList, Modal } from 'DVWebNodeUI'
import {
  withSpaContext,
  SpaContextProps,
} from '../SpaContext'
import { fillValues } from 'DVWebNodeUtils'
import * as st from './DownloadButton.module.scss'
import history from '../../../widgets/DVWebNodeSPA/history'

export type DownloadActionProps = {
  downloadInfo?: {
    downloadURL: string
    titleID: string
    episodeNumber: undefined | number
  }
  withLabel?: boolean
}

export type DownloadActionWithSpaContextProps = SpaContextProps & DownloadActionProps

type DownloadActionState = {
  downloadStatus: DownloadStatus
  downloadProgress: number
  downloadStatusMessages: StatusMessage[]
  downloadId?: string
  defaultChecked: boolean
}

const getDownloadStatus = (titleID: string, downloads: AllDownloadsPayload) => {
  return titleID && downloads && downloads[titleID]
}

const getDownloadId = (props: DownloadActionWithSpaContextProps) => {
  return props.downloads && props.downloadInfo && props.downloads[props.downloadInfo.titleID]
  && props.downloads[props.downloadInfo.titleID].DownloadId
}

const getDownloadStateFromProps = (props: DownloadActionWithSpaContextProps, state?: DownloadActionState) => {
  const downloadStatus = props.downloadInfo && getDownloadStatus(props.downloadInfo.titleID, props.downloads)

  return {
    downloadStatus: (downloadStatus && DownloadStatus[downloadStatus.Status]) || DownloadStatus.IDLE,
    downloadProgress: downloadStatus && downloadStatus.Progress || 0,
    downloadStatusMessages: downloadStatus && downloadStatus.StatusMessages,
    downloadId: downloadStatus && props.downloads[props.downloadInfo.titleID].DownloadId,
    defaultChecked: state ? state.defaultChecked : false
  }
}

export class DownloadActionWithSpaContext extends React.Component<
  DownloadActionWithSpaContextProps,
  DownloadActionState
> {
  modal = React.createRef<Modal>();
  
  constructor(props: DownloadActionWithSpaContextProps) {
    super(props)
    this.state = getDownloadStateFromProps(props)
  }

  startDownload = (e: React.MouseEvent) => {
    e.preventDefault()
    const { downloadInfo: {titleID}, saveOfflineData} = this.props

    this.setState({
      downloadStatus: DownloadStatus.WAITING,
      downloadId: getDownloadId(this.props),
    }, () => {
      UWPNotifier.getInstance().publish(OutputAction.Download_Start, {
      titleId: titleID,
      ...(this.state.downloadId && { downloadId: this.state.downloadId })
    })
    })

    saveOfflineData(titleID)
  }

  pauseDownload = (e: React.MouseEvent) => {
    e.preventDefault()
    UWPNotifier.getInstance().publish(OutputAction.Download_Pause, {
      titleId: this.props.downloadInfo.titleID,
      ...(this.state.downloadId && { downloadId: this.state.downloadId })
    })
    this.onChange()
  }

  resumeDownload = (e: React.MouseEvent) => {
    e.preventDefault()
    UWPNotifier.getInstance().publish(OutputAction.Download_Resume, {
      titleId: this.props.downloadInfo.titleID,
      ...(this.state.downloadId && { downloadId: this.state.downloadId })
    })
    this.onChange()
  }

  deleteDownload = (e: React.MouseEvent) => {
    e.preventDefault()
    UWPNotifier.getInstance().publish(OutputAction.Download_Delete, {
      titleId: this.props.downloadInfo.titleID,
      ...(this.state.downloadId && { downloadId: this.state.downloadId })
    })
  }

  cancelDownload = (e: React.MouseEvent) => {
    e.preventDefault()
    UWPNotifier.getInstance().publish(OutputAction.Download_Cancel, {
      titleId: this.props.downloadInfo.titleID,
      ...(this.state.downloadId && { downloadId: this.state.downloadId })
    })
  }

  retryDownload = (e: React.MouseEvent) => {
    e.preventDefault()
    UWPNotifier.getInstance().publish(OutputAction.Download_Retry, {
      titleId: this.props.downloadInfo.titleID,
      ...(this.state.downloadId && { downloadId: this.state.downloadId })
    })
  }

  playDownload = (e: React.MouseEvent) => {
    e.preventDefault()
    UWPNotifier.getInstance().publish(OutputAction.Download_Play, {
      titleId: this.props.downloadInfo.titleID,
      ...(this.state.downloadId && { downloadId: this.state.downloadId })
    })
    this.onChange()
  }

  viewDetail = (e: React.MouseEvent) => {
    e.preventDefault()
    if(this.props.downloadInfo && this.props.downloadInfo.titleID){
      history.push(`/detail/${this.props.downloadInfo.titleID}`)
      this.onChange()
    }
  }
  
  viewError = (e: React.MouseEvent) => {
    e.preventDefault()
    this.modal.current.open()
    this.onChange()
  }

  noActionDownload = (e: React.MouseEvent) => {
    e.preventDefault()
    count('no-action')
  }

  getDownloadAction = () => {
    const { strings } = this.props
    // To be done at a later stage: const startDownloadLink = { text: strings.DV_WINAPP_DROPLIST_STARTDL, onClick: this.startDownload, className: st.startDownload }
    const cancelDownloadLink = { text: strings.DV_WINAPP_DROPLIST_CANCELDL, onClick: this.cancelDownload, className: st.cancelDownload }
    const pauseDownloadLink = { text: strings.DV_WINAPP_DROPLIST_PAUSEDL, onClick: this.pauseDownload, className: st.pauseDownload }
    const viewDetailsLink = { text: strings.DV_WINAPP_DROPLIST_VIEWDETAIL, onClick: this.viewDetail, className: st.viewDetails }
    const resumeDownloadLink = { text: strings.DV_WINAPP_DROPLIST_RESUMEDL, onClick: this.resumeDownload, className: st.resumeDownload }
    const retryDownloadLink = { text: strings.DV_WINAPP_DROPLIST_RETRYDL, onClick: this.retryDownload, className: st.retryDownload }
    const deleteDownloadLink = { text: strings.DV_WINAPP_DROPLIST_DELETEDL, onClick: this.deleteDownload, className: st.retryDownload }
    const playDownloadLink = { text: strings.DV_WINAPP_DROPLIST_PLAY, onClick: this.playDownload, className: st.playDownload }
    const viewErrorLink = { text: strings.DV_WINAPP_DROPLIST_ERROR, onClick: this.viewError, className: st.viewError }
    
    switch (this.state.downloadStatus) {
      case DownloadStatus.IDLE:
        return { action: this.startDownload, links: [] }
      case DownloadStatus.WAITING:
        return { action: this.noActionDownload, links: [] }
      case DownloadStatus.QUEUED:
        return { action: this.noActionDownload, links: [cancelDownloadLink, viewDetailsLink]}
      case DownloadStatus.DOWNLOADING:
        return { action: this.pauseDownload, links: [pauseDownloadLink, cancelDownloadLink, viewDetailsLink]}
      case DownloadStatus.PAUSED:
        return { action: this.resumeDownload, links: [resumeDownloadLink, cancelDownloadLink, viewDetailsLink]}
      case DownloadStatus.ERROR:
        return { action: this.retryDownload, links: [retryDownloadLink, cancelDownloadLink, viewDetailsLink, viewErrorLink]}
      case DownloadStatus.COMPLETED:
        return { action: this.deleteDownload, links: [playDownloadLink, deleteDownloadLink, viewDetailsLink]}
      default:
        return { action: this.noActionDownload, links: [] }
    }
  }

  componentDidUpdate(prevProps: DownloadActionWithSpaContextProps) {
    const prevDownloadState = getDownloadStatus(prevProps.downloadInfo.titleID, prevProps.downloads)
    const prevStatus = prevDownloadState && prevDownloadState.Status
    const prevProgress = prevDownloadState && prevDownloadState.Progress

    const newDownloadState = getDownloadStatus(this.props.downloadInfo.titleID, this.props.downloads)
    const newStatus = newDownloadState && newDownloadState.Status
    const newProgress = newDownloadState && newDownloadState.Progress

    if (prevStatus !== newStatus || prevProgress !== newProgress) {
      const downloadState = getDownloadStateFromProps(this.props, this.state)
      this.setState({
        ...downloadState,
      })
    }
  }

  onChange = () => {
    this.setState({
      defaultChecked: !this.state.defaultChecked
    })
  }

  shouldDropListHaveLabel = () => {
    switch (this.state.downloadStatus) {
      case DownloadStatus.QUEUED:
      case DownloadStatus.DOWNLOADING:
      case DownloadStatus.PAUSED:
      case DownloadStatus.ERROR:
        return true
      case DownloadStatus.IDLE:
      case DownloadStatus.WAITING:
      case DownloadStatus.COMPLETED:
        return false
      default:
        return false
    }
  }

  render() {
    const { downloadInfo, withLabel, strings } = this.props
    
    if (!downloadInfo) {
      return null
    }

    const isEpisode = typeof downloadInfo.episodeNumber !== 'undefined'
    const episodeText = downloadInfo.episodeNumber === 0 ? strings.DV_WINAPP_EPISODE_BONUS : fillValues(strings.DV_WINAPP_EPISODE_NB, {episodeNumber: String(downloadInfo.episodeNumber)})

    const downloadAction = this.getDownloadAction()
    const hasDropList = Boolean(downloadAction && downloadAction.links.length)
    const dropListWithLabel = hasDropList && this.shouldDropListHaveLabel()

    const labelAction = {
      IDLE: strings.DV_WINAPP_ACTION_IDLE,
      WAITING: strings.DV_WINAPP_ACTION_WAITING,
      QUEUED: strings.DV_WINAPP_ACTION_QUEUED,
      DOWNLOADING: strings.DV_WINAPP_ACTION_DOWNLOADING,
      PAUSED: strings.DV_WINAPP_ACTION_PAUSED,
      ERROR: strings.DV_WINAPP_ACTION_ERROR,
      COMPLETED: strings.DV_WINAPP_ACTION_COMPLETED,
      REMOVED: strings.DV_WINAPP_ACTION_REMOVED,
      CANCELLED: strings.DV_WINAPP_ACTION_CANCELLED
    }

    const labelActionForEpisodes = {
      IDLE: fillValues(strings.DV_WINAPP_ACTION_IDLE_EPISODES, {episodeText}),
      WAITING: strings.DV_WINAPP_ACTION_WAITING,
      QUEUED: fillValues(strings.DV_WINAPP_ACTION_QUEUED),
      DOWNLOADING: fillValues(strings.DV_WINAPP_ACTION_DOWNLOADING_EPISODES, {episodeText}),
      PAUSED: fillValues(strings.DV_WINAPP_ACTION_PAUSED_EPISODES, {episodeText}),
      ERROR: fillValues(strings.DV_WINAPP_ACTION_ERROR_EPISODES, {episodeText}),
      COMPLETED: fillValues(strings.DV_WINAPP_ACTION_COMPLETED_EPISODES, {episodeText}),
      REMOVED: fillValues(strings.DV_WINAPP_ACTION_REMOVED_EPISODES, {episodeText}),
      CANCELLED: fillValues(strings.DV_WINAPP_ACTION_CANCELLED_EPISODES, {episodeText})
    }

    const label = isEpisode ? labelActionForEpisodes[this.state.downloadStatus] : labelAction[this.state.downloadStatus]

    const { downloadURL } = downloadInfo

    const downloadButtonProps = {
      label,
      downloadURL,
      status: this.state.downloadStatus,
      progress: this.state.downloadProgress,
      onClick: downloadAction.action
    }

    // Detail Page ATF Button
    const CardDownloadButton = () => ( withLabel ? (
      <DownloadButtonWithLabel
        {...downloadButtonProps}
        forceDoubleHeight={true}
      />
    ) : (
      (!hasDropList) ? // Detail Page BTF/Download page buttons
        <DownloadButton {...downloadButtonProps} /> :
        <DropList right={true} onChange={this.onChange} defaultChecked={this.state.defaultChecked} className={st.downloadAction} links={downloadAction.links} customText={" "} customTextChildren={
          <>
            {dropListWithLabel && <span className={st.dropListLabel}>{label}</span>}
            <DownloadButton {...downloadButtonProps} isDropList={true} />
          </>
        } />
    ))

    return (
      <div className="avu-full-width-phablet" data-automation-id="download-button">
        <CardDownloadButton />
        {(this.state.downloadStatusMessages && this.state.downloadStatusMessages.length) && <Modal modalId={`modal-error-${downloadInfo.titleID}`} ref={this.modal} footer={""} header={strings.DV_WINAPP_DOWNLOAD_ERROR}>
          <DownloadStatusMessages messages={this.state.downloadStatusMessages} strings={strings} />
        </Modal>}
      </div>
    )
  }
}

export const DownloadAction = withSpaContext(DownloadActionWithSpaContext)
